import NICHES from "../../public/niches.json";
import type { Lang } from "@/i18n";

/** O pagină de nișă, în forma în care o scrie scripts/niches.mjs.
 *
 *  La fel ca la blog, fișierul e generat la build și citit de trei consumatori
 *  care nu pot împărți un import: clientul prin Vite, serverul din WEB_DIST
 *  pentru meta și JSON-LD, prerandarea pentru lista de rute. */
export interface NicheLang {
  /** Titlul din <title>, cu sufixul de brand adăugat de compilator în rute. */
  title: string;
  /** Titlul de pe pagină. Separat de `title` fiindcă unul e pentru rezultatul
   *  de căutare și celălalt pentru om — în rezultat contează cuvântul căutat,
   *  pe pagină contează să nu sune a formular. */
  h1: string;
  summary: string;
  html: string;
  toc: Array<{ id: string; text: string; level: number }>;
  /** Perechile de sub titlurile de nivel 3, scoase de compilator. Devin
   *  FAQPage în structured data — de aceea sunt date, nu doar marcaj. */
  faq: Array<{ question: string; answer: string }>;
  words: number;
}

export interface NichePage {
  slug: string;
  /** „vertical" = o industrie, „geo" = un loc, „geo-service" = serviciu în loc.
   *  Alege forma din structured data și gruparea din index. */
  kind: "vertical" | "geo" | "geo-service";
  /** Serviciul spre care trimite pagina. Nișa e ușa, serviciul e destinația. */
  service: string;
  /** Cazul care o ilustrează, când există unul potrivit. */
  case?: string;
  order?: number;
  langs: Record<string, NicheLang>;
}

export const NICHES_ALL = NICHES.pages as NichePage[];

/** Bucățile de adresă. Lista vine din conținut, deci nu are cum să devieze de
 *  arborele de rute al prerandării — spre deosebire de o listă scrisă de mână,
 *  care a deviat deja de trei ori pe site-ul ăsta. */
export const NICHE_SLUGS: readonly string[] = NICHES_ALL.map((p) => p.slug);

export function nicheBySlug(slug: string): NichePage | undefined {
  return NICHES_ALL.find((p) => p.slug === slug);
}

export function nicheText(p: NichePage, lang: Lang): NicheLang {
  return p.langs[lang] ?? p.langs.en;
}
